import { render, staticRenderFns } from "./Creator-Role.vue?vue&type=template&id=9e752994&"
import script from "./Creator-Role.vue?vue&type=script&lang=ts&"
export * from "./Creator-Role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports